module.exports = __webpack_public_path__ + "img/tema-1-1.d914516b.svg";